import { isContainerDiscountApplicable } from "../isContainerDiscountApplicable/index.js";
import type { SupplierRetailerConnectionDiscountItemType } from "../supplierRetailerConnectionDiscountCommons.js";

export const findApplicableContainerDiscounts = ({
  connectionDiscounts,
  productContainerType,
}: {
  connectionDiscounts:
    | {
        deletedAt: Date | null;
        discountAmount: number;
        type: "flat" | "percentage";
        itemType: SupplierRetailerConnectionDiscountItemType | null;
      }[]
    | undefined;
  productContainerType: string | null;
}) => {
  if (!connectionDiscounts) {
    return undefined;
  }

  return connectionDiscounts.filter((discount) =>
    isContainerDiscountApplicable({
      discount,
      productContainerType,
    }),
  );
};
